import {FC, PropsWithChildren} from 'react';
import {Box, BoxProps} from '@mui/material';

import Logo from '@/shared/images/logo.svg?react';
import {COLOR__WHITE} from '@/theme/colors';

interface Props extends PropsWithChildren {
  cardProps?: BoxProps<'form'>;
}

export const DesktopAuthLayout: FC<Props> = ({children, cardProps}) => {
  const {sx: cardSx, ...restCardProps} = cardProps ?? {};

  return (
    <Box
      minHeight="100dvh"
      sx={{
        background: 'linear-gradient(180deg, #F0D7FE 0%, #AEDAFD 100%)',
      }}
      display="flex"
      flexDirection="column"
      px={2}
      py={4}
    >
      <Box flex={1} display="flex" alignItems="center" justifyContent="center">
        <Logo width={87} height={'100%'} />
      </Box>

      <Box
        component="form"
        width="100%"
        maxWidth={460}
        mx="auto"
        sx={{
          borderRadius: '16px',
          backgroundColor: COLOR__WHITE,
          p: '60px',
          ...cardSx,
        }}
        {...restCardProps}
      >
        {children}
      </Box>

      <Box flex={1} />
    </Box>
  );
};
